export const SEATS_OPTIONS = {
    3: 3,
    5: 5,
    10: 10,
    15: 15,
    20: 20,
    25: 25,
    30: 30,
    40: 40,
    50: 50,
    100: 100,
    "200+": 200
};
export const CONTACTS_OPTIONS = {
    2000: 2000,
    4000: 4000,
    7000: 7000,
    12000: 12000,
    27000: 27000,
    52000: 52000,
    60000: 60000
};
export const MAX_NO_TOUCH_SEATS = 50;
export const MAX_NO_TOUCH_CONTACTS = 60000;
export const MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_PRO = 10;
export const MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_PRO = 2000;
export const MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = 40;
export const MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = 60000;
export const UNIT_OF_MEASURE = {
    CONTACTS: "contacts",
    SEATS: "seats"
};
export const UNIT_OF_MEASURE_OPTIONS = [
    {
        value: UNIT_OF_MEASURE.SEATS,
        text: "Seats"
    },
    {
        value: UNIT_OF_MEASURE.CONTACTS,
        text: "Contacts"
    }
];
export const BUCKET_OPTIONS = {
    [UNIT_OF_MEASURE.CONTACTS]: CONTACTS_OPTIONS,
    [UNIT_OF_MEASURE.SEATS]: SEATS_OPTIONS
};
export const MAX_NO_TOUCH_BUCKET_SIZE = {
    [UNIT_OF_MEASURE.CONTACTS]: MAX_NO_TOUCH_CONTACTS,
    [UNIT_OF_MEASURE.SEATS]: MAX_NO_TOUCH_SEATS
};
export const MIN_BUCKET_SIZE_TO_RECOMMEND_PRO = {
    [UNIT_OF_MEASURE.CONTACTS]: MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_PRO,
    [UNIT_OF_MEASURE.SEATS]: MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_PRO
};
export const MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = {
    [UNIT_OF_MEASURE.CONTACTS]: MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE,
    [UNIT_OF_MEASURE.SEATS]: MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE
};
export const UNIT_OF_MEASURE_LABELS = {
    [UNIT_OF_MEASURE.CONTACTS]: "pricingPage.contacts",
    [UNIT_OF_MEASURE.SEATS]: "pricingPage.seats"
};
export const UNIT_OF_MEASURE_SELECTOR_LABELS = {
    [UNIT_OF_MEASURE.CONTACTS]: "pricingPage.numberOfContacts",
    [UNIT_OF_MEASURE.SEATS]: "pricingPage.chooseTeamSize"
};
export const PRICING_TYPES = {
    FIXED: "fixed",
    PER_UNIT: "per-unit"
};
